import React, { useState } from "react";
import validateForm from "../../../utils/Validation";
import { ADD_NEW_BUDGET } from "../../../config/API_Collection";
import Axios from "../../../utils/Axios";
import AuthHandler from "../../../utils/AuthHandler";
import { useNavigate } from "react-router-dom";

const AddBudget = ({
  data,
  showToast,
  CloseModalAdd,
  refreshProjectData,
  setToast,
  canAddBudget,
}) => {
  const navigate = useNavigate();
  const [isSubmittingAdd, setIsSubmittingAdd] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleAddBudget = async (e) => {
    e.preventDefault();
    if (isSubmittingAdd) return;
    setIsSubmittingAdd(true);

    try {
      const formData = e.target;
      const payload = {
        project_id: parseInt(data.project_data.pid),
        budget_name: formData.budget_name.value,
        budget_type: formData.budget_type.value,
        allocated_amount: formData.allocated_amount.value,
      };

      const requiredFields = ["budget_name", "budget_type", "allocated_amount"];
      const errors = validateForm(payload, requiredFields);
      setFormErrors(errors);

      if (Object.keys(errors).length > 0) {
        setIsSubmittingAdd(false); // re-enable on validation failure
        return;
      }

      const response = await Axios.post(ADD_NEW_BUDGET, payload);
      if (response.status === 200) {
        showToast("Budget Added Successfully!", "success");
        CloseModalAdd();
        refreshProjectData();
        return; // keep disabled; modal is closing
      }

      showToast(response?.data?.message || "Failed to add budget", "failed");
      setIsSubmittingAdd(false); // re-enable on API failure
    } catch (error) {
      AuthHandler(error.response?.status, setToast, navigate);
      showToast(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to add budget",
        "failed"
      );
      setIsSubmittingAdd(false); // re-enable on error
    }
  };
  return (
    <div className="add-budget-container">
      <form className="budget-form" onSubmit={handleAddBudget}>
        {/* Wrap fields + submit in a disabled fieldset */}
        <fieldset
          disabled={isSubmittingAdd}
          style={{ border: 0, padding: 0, margin: 0 }}
        >
          <div className="form-row">
            <div
              className={`form-group flex-item ${
                formErrors.budget_name ? "has-error" : ""
              }`}
            >
              <label>Budget Name *</label>
              <input type="text" name="budget_name" />
            </div>
          </div>

          <div className="form-row">
            <div
              className={`form-group flex-item ${
                formErrors.budget_type ? "has-error" : ""
              }`}
            >
              <label>Budget Type *</label>
              <select name="budget_type" defaultValue="Time">
                <option value="Time">Time</option>
                <option value="Expenses">Expenses</option>
              </select>
            </div>

            <div
              className={`form-group flex-item ${
                formErrors.allocated_amount ? "has-error" : ""
              }`}
            >
              <label>Budget Amount (NZD) *</label>
              <input type="number" name="allocated_amount" defaultValue={0} />
            </div>
          </div>

          <div className="d-flex justify-content-center">
            {" "}
            {canAddBudget && (
              <button type="submit" className="btn btn-primary">
                {isSubmittingAdd ? "Creating..." : "Create Budget"}
              </button>
            )}
            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={CloseModalAdd}
            >
              Cancel
            </button>
          </div>
        </fieldset>

        {/* Cancel stays enabled */}
      </form>
    </div>
  );
};

export default AddBudget;
